import type { CanDeactivateFn } from '@angular/router';
import type { VotingTaskComponent } from './voting-task.component';
export const votingTaskNavigationGuard: CanDeactivateFn<VotingTaskComponent> = (
  component,
) => component.confirmNavigation();
